module.exports = __webpack_public_path__ + "img/backup-empty.791c6136.png";